import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SharedService } from 'src/app/shared/services/shared.service';
import { jwtDecode } from 'jwt-decode';
import { ProfileService } from './profile.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class AuthService extends SharedService {
    constructor(public http: HttpClient, private router: Router, private profileService: ProfileService) {
        super(http, 'auth');
    }
    redirect_uri_keycloak = environment.REDIRECT_URI;
    logout(): void {
        this.dispatchData({ singIn: false });
        localStorage.removeItem('auth_user');
        localStorage.removeItem('auth_token');
        this.removeEcosistema();
        localStorage.removeItem('param-185');
        this.profileService.clearProfile();
        this.router.navigate(['/public']);
    }
}
